"use client";

import React from "react";
import { Button, ButtonProps } from "@mui/material";

interface CustomButtonProps extends ButtonProps {
  text: string;
}

const CustomButton: React.FC<CustomButtonProps> = ({
  text,
  variant = "contained",
  sx,
  ...props
}) => {
  return (
    <Button
      variant={variant}
      sx={{
        minWidth: "100px",
        background: "#4d92d9",
        border: "2px solid #4d92d9",
        ":hover": {
          background: "transparent",
          color: "#4d92d9",
          transition: "0.4s",
        },
        ...sx,
      }}
      {...props}
    >
      {text}
    </Button>
  );
};

export default CustomButton;
